import React from 'react'
const LoadMore = ({btnTitle}) => {
  return (
    <div className="loadmore">
      <button>
        <div className='text'>{btnTitle}</div>
      </button>
    </div>
  );
}

export default LoadMore;